import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class StoreTypeService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
              ) { }

   getStoreTypeList() {
        return this.http.get(this.global.httpUrl+"store-types");
   }

   getStoreTypeById(id: any) {
        return this.http.get(this.global.httpUrl+"store-types/"+id);
   } 

   createStoreType(data: any){
        return this.http.post(this.global.httpUrl+"store-types", data); 
   }

   updateStoreType(data: any,id: any){
        return this.http.put(this.global.httpUrl+"store-types/"+id, data); 
   } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/store_types/store-type.service.ts